
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Agent } from './AgentChatbox.vue';

@Component
export default class AgentBrowser extends Vue {
  @Prop({ default: () => [] })
  public agents!: Agent[];

  @Prop({ default: false })
  public loading!: boolean;

  @Prop({ default: null })
  public error!: string | null;

  public activeFilter: number = 0;

  public get filteredAgents(): Agent[] {
    let filtered = this.agents;

    // Apply filter
    switch (this.activeFilter) {
      case 1: // Favorites
        filtered = filtered.filter(agent => agent.isFavorite);
        break;
      default: // All
        break;
    }

    return filtered;
  }

  public get recommendedAgents(): Agent[] {
    return this.filteredAgents.filter(agent => agent.isRecommended);
  }

  public get otherAgents(): Agent[] {
    return this.filteredAgents.filter(agent => !agent.isRecommended);
  }

  public selectAgent(agent: Agent) {
    this.$emit('select-agent', agent);
  }

  public toggleFavorite(agent: Agent) {
    this.$emit('toggle-favorite', agent.id);
  }

  public refreshAgents() {
    this.$emit('refresh');
  }

  public getAgentColor(avatar: string): string {
    // Use consistent blue color for all agents (especially mdi-assistant)
    const colorMap: { [key: string]: string } = {
      'mdi-assistant': '#1976D2',
      'mdi-briefcase': '#1976D2',
      'mdi-chart-line': '#1976D2',
      'mdi-view-dashboard': '#1976D2',
      'mdi-block-helper': '#1976D2',
      'mdi-account-voice': '#1976D2',
      'mdi-bug': '#1976D2',
      'mdi-robot': '#1976D2',
    };
    return colorMap[avatar] || '#1976D2';
  }
}
